import {Component, OnDestroy, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {UserLoginService} from "../../../service/user-login.service";
import {CognitoCallback} from "../../../service/cognito-util.service";
import { MatDialog, MatDialogRef} from '@angular/material';
import { ForgotPasswordStep2DialogComponent } from './forgotPasswordStep2Dialog.component';
const scheduleMicrotask = Promise.resolve(null);
@Component({
    selector: 'forgotPasswordStep2-app',
    templateUrl: './forgotPasswordStep2.html'
})
export class ForgotPasswordStep2Component implements CognitoCallback, OnInit, OnDestroy {

    verificationCode: string;
    email: string;
    password: string;
    errorMessage: string;
    private sub: any;

    constructor(public router: Router, public route: ActivatedRoute,
                public userService: UserLoginService,
                private dialog: MatDialog) {
        console.log("email from the url: " + this.email);
    }

    ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
            this.email = params['email'];

        });
        this.errorMessage = null;
        scheduleMicrotask.then(() => {
            this.openDialog();
          });
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    onNext() {
        this.errorMessage = null;
        this.userService.confirmNewPassword(this.email, this.verificationCode, this.password, this);
    }

    cognitoCallback(message: string) {
        if (message != null) { //error
            this.errorMessage = message;
            console.log("result: " + this.errorMessage);
            this.openDialog();
        } else { //success
            this.router.navigate(['/kirjaudu']);
        }
    }

    openDialog() {
        
        let dialogRef = this.dialog.open(ForgotPasswordStep2DialogComponent, {
            data: {errorMessage: this.errorMessage},
        });
        dialogRef.afterClosed().subscribe(result => {
          if(result){
            
            console.log('result.verificationCode:'+result.verificationCode);
            console.log('result.password:'+result.password);
            
            this.errorMessage = null;
            this.userService.confirmNewPassword(this.email,result.verificationCode, result.password, this);
          }
          else {
            this.router.navigate(['/etusivu']);
          }
        });
    }
}





// WEBPACK FOOTER //
// ./src/app/public/auth/forgot/forgotPasswordStep2.component.ts